import {
  required, maxLength,
} from 'vuelidate/lib/validators';

export default {
  headers: [
    { text: 'Názov', value: 'name' },
    { text: 'Default hodnota', value: 'default_value' },
    { text: 'Typ', value: 'type' },
    { text: 'Vytvorený', value: 'created_at' },
    { text: 'Upravený', value: 'updated_at' },
    { text: 'Akcie', value: 'action', sortable: false },
  ],
  formModel: [{
    name: 'name',
    type: 'text',
    label: 'Názov',
    class: 'sm6',
    icon: 'person',
    validations: {
      required, maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'default_value',
    type: 'text',
    label: 'Default hodnota',
    // class: 'sm12',
    class: 'sm6',
    icon: 'email',
    validations: {
      required, maxLength: maxLength(255),
    },
    // defaultValue: 'test'
  },
  {
    name: 'type',
    type: 'select',
    label: 'Typ',
    class: '',
    icon: 'build',
    defaultValue: [
      { text: 'Text', value: 'text' },
      { text: 'Dátum', value: 'date' },
      { text: 'Checkbox', value: 'switch' },
      { text: 'Súbor', value: 'file' },
    ],
  },
  ],
};
